export default __webpack_public_path__ + "static/media/icon-content-blue.33118184.svg";